import { APIPath } from '../constant'
import { BaseService } from './base'

class PhoneOnboarding {
    save({ countryCode, nationalNumber, platform = 'Web' }) {
        return BaseService.post(APIPath.userPhone, {
            CountryCode: countryCode,
            NationalNumber: nationalNumber,
            Platform: platform,
        })
    }
}

const PhoneOnboardingService = new PhoneOnboarding()
Object.freeze(PhoneOnboardingService)
export { PhoneOnboardingService }
